define('colors', function () {
    return {
        'yellow': '#fff52e',
        'green': '#22b573',
        'white': '#ffffff',
        'gray': '#5a616c',
        'darkGray': '#272c33',
        'lightGray': '#96999e',
        'darkBlue': '#1b4d71',
        'brick': '#b14821',
        'mustard': '#c3ae5e',
        'darkMustard': '#b17221',
        'purple': '#c35e7c',
        'blue': '#4FA2C3'
    }
});